export default __webpack_public_path__ + "static/media/153811539_465491337922780_8121976056119946985_n.b0da201a.jpg";